module.exports = __webpack_public_path__ + "d3356a5728edcb917fad39c7f3817502.png";